import { Chip, Props, StatusChipVariant, Text, text } from "./StatusChip.Parts";
import { ActiveIcon } from "./icons/active/Active";
import { InactiveIcon } from "./icons/inactive/Inactive";
import { PendingIcon } from "./icons/pending/Pending";

export const StatusChip = ({
  variant = StatusChipVariant.Active,
  iconOnly,
  label,
  ...props
}: Props) => {
  return (
    <Chip $variant={variant} {...props}>
      {(variant === StatusChipVariant.Active ||
        variant === StatusChipVariant.InPerpetuity) && <ActiveIcon />}
      {variant === StatusChipVariant.Pending && <PendingIcon />}
      {variant === StatusChipVariant.Inactive && <InactiveIcon />}
      {!iconOnly && <Text>{label || text[variant]}</Text>}
    </Chip>
  );
};
